import React from 'react';
import people from '../../assets/people.png';
import ai from '../../assets/ai.png';
import './header.css';

const Header = () => (
  <div className="gpt3__header section__padding" id="home">
    <div className="gpt3__header-content">
      <h1 className="gradient__text">Build Something Amazing with GPT-3</h1>
      <p>300+ applications are using GPT-3, and tens of thousands of developers around the globe are building on the platform. We currently generate an average of 4.5 billion words per day, and continue to scale production traffic.</p>

      <div className="gpt3__header-content__input">
        <input type="email" placeholder="Your Email Address" />
        <button type="button">Get Started</button>
      </div>

      <div className="gpt3__header-content__people">
        <img src={people} alt='people' />
        <p>1,669 access requests in last 24 hours</p>
      </div>
    </div>

    {/* Moving this div up one level into the other div will put the image underneath the content */}
    <div className="gpt3__header-image">
      <img src={ai} alt='ai' />
    </div>
  </div>
);

export default Header; 